<template>
  <b-modal  scrollable size="lg" v-model="show" centered :title="hhType === 'E' ? 'Einnahmekonto wählen' : 'Ausgabekonto wählen'">
    <b-row>
      <b-col md="4">
        <b-form-input type="search" v-model="search" placeholder="Suchen" debounce="200" style="margin-bottom: 6px"></b-form-input>
      </b-col>
      <b-col><b-button variant="primary" class="" @click="$emit('add-hh'); show = false">Neues Konto anlegen</b-button></b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table id="my-table" :items="remainingHhs"
                 striped hover selectable
                 :fields="fields"
                 :sort-by="sortBy"
                 :sort-desc="sortDesc"
                 select-mode="single"
                 selectedVariant="primary"
                 @row-selected="rowSelected">
          <template #table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                style="min-width: 100px"
            >
          </template>
        </b-table>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" variant="success" :disabled="!canContinue" @click="onSave">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "SelectHhDialog",
  props:{
    hhType: {
      type: String,
      default: () => 'E'
    },
    hhs: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      search: '',
      sortBy: 'account',
      sortDesc: false,
      show: false,
      newAddress: {},
      selected: [],
      fields: [
        {key: "account", label: 'Konto', sortable: true},
        {key: "name", label: 'Name', sortable: true},
      ],

    }
  },
  computed: {
    canContinue() {
      return this.selected.length > 0;
    },
    remainingHhs: function () {
      let res = [];
      const filterText = this.search.trim().toLowerCase();
      if (filterText === "") {
        return this.hhs;
      }
      for (let i = 0; i < this.hhs.length; i++) {
        if (
            this.hhs[i].name.toLowerCase().indexOf(filterText) > -1
            || this.hhs[i].account.toLowerCase().indexOf(filterText) > -1
        ) {
          res.push(this.hhs[i]);
        }
      }
      return res;
    }
  },
  methods: {
    rowSelected(items) {
      if (items.length === 0) {
        this.selected = [];
      } else {
        this.selected = items;
      }
    },
    onSave() {
      this.show = false;
      this.$emit("set-hh", this.getReturnData());
    },
    onCancel() {
      this.show = false;
    },
    showDialog() {
      this.selected = [];
      this.search = '';
      this.show = true;
    },
    getReturnData: function () {
      return this.selected[0];
    },
  }
}
</script>

<style scoped>
</style>
